"use strict";
export const QUOTE_REQUEST_TIMEOUT_MS = 8e3;
export function quoteRequestTimeoutSignal() {
  return typeof AbortSignal !== "undefined" && typeof AbortSignal.timeout === "function" ? AbortSignal.timeout(QUOTE_REQUEST_TIMEOUT_MS) : void 0;
}
